<template>
  <Transition name="fade">
    <div v-if="gameLaunchError" class="modal-backdrop" @click.self="close">
      <section ref="dialog" class="launch-error-dialog" role="dialog" aria-modal="true" aria-labelledby="launch-error-title" aria-describedby="launch-error-reason" tabindex="-1" @keydown="handleKey">
        <button class="modal-close" aria-label="关闭启动失败提示" @click="close">×</button>
        <span class="launch-error-icon" aria-hidden="true">!</span>
        <h2 id="launch-error-title">{{ gameLaunchError.restricted ? '场馆使用提示' : '暂时无法进入游戏' }}</h2>
        <p class="launch-error-game">{{ gameLaunchError.gameName }}<span v-if="gameLaunchError.venueName"> · {{ gameLaunchError.venueName }}</span></p>
        <div class="launch-error-reason">
          <span>{{ gameLaunchError.restricted ? '使用说明' : '失败原因' }}</span>
          <p id="launch-error-reason">{{ gameLaunchError.message }}</p>
        </div>
        <p class="launch-error-help">如仍无法进入，可联系客服协助处理。</p>
        <label v-if="gameLaunchError.redirectVenues?.length > 1" class="launch-target-label">
          请选择跳转场馆
          <select v-model="selectedTargetId" aria-label="跳转场馆">
            <option v-for="target in gameLaunchError.redirectVenues" :key="target.id" :value="target.id">{{ target.name }}</option>
          </select>
        </label>
        <div class="launch-error-actions">
          <button @click="contactSupport">联系客服</button>
          <button v-if="gameLaunchError.redirectVenues?.length" class="primary" @click="redirect">前往游戏</button>
          <button v-else class="primary" @click="close">知道了</button>
        </div>
      </section>
    </div>
  </Transition>
</template>

<script setup>
import { nextTick, onBeforeUnmount, ref, watch } from 'vue'
import { useAppContext } from '../../composables/appContext'

const { gameLaunchError, openCustomerService, goRestrictedVenue } = useAppContext()
const dialog = ref(null)
const selectedTargetId = ref(null)
let previousFocus

function restoreFocus() {
  if (previousFocus?.isConnected) previousFocus.focus()
  previousFocus = null
}
function close() {
  gameLaunchError.value = null
}
function redirect() {
  const target = gameLaunchError.value?.redirectVenues?.find(item => item.id === selectedTargetId.value)
  if (target) goRestrictedVenue(target)
}
function contactSupport() {
  close()
  openCustomerService()
}
function handleKey(event) {
  if (event.key === 'Escape') {
    event.preventDefault()
    close()
  } else if (event.key === 'Tab') {
    const buttons = [...dialog.value.querySelectorAll('button,select')]
    const first = buttons[0]
    const last = buttons[buttons.length - 1]
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.value)) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog.value)) {
      event.preventDefault()
      first.focus()
    }
  }
}
watch(gameLaunchError, async (value, previous) => {
  if (!value) return restoreFocus()
  selectedTargetId.value = value.redirectVenues?.[0]?.id || null
  if (!previous) previousFocus = document.activeElement
  await nextTick()
  dialog.value?.focus()
}, { immediate: true })
onBeforeUnmount(restoreFocus)
</script>

<style scoped>
.launch-target-label { display: grid; gap: 8px; margin-top: 16px; }
.launch-target-label select { min-height: 44px; padding: 8px; border: 1px solid #cad7e4; border-radius: 8px; }
.launch-error-dialog { position: relative; width: min(440px, 100%); max-height: calc(100dvh - 40px); overflow: auto; padding: 32px; border-radius: 20px; background: #fff; color: #344863; box-shadow: 0 24px 80px #142b4b33; }
.launch-error-icon { display: grid; place-items: center; width: 48px; height: 48px; margin-bottom: 20px; border-radius: 14px; color: #ad382d; background: #fff0ee; font-size: 28px; font-weight: 700; }
h2 { margin: 0; font-size: 23px; }
.launch-error-game { margin: 10px 0 22px; color: #728198; overflow-wrap: anywhere; }
.launch-error-reason { padding: 16px; border-radius: 12px; background: #f5f8fc; }
.launch-error-reason > span { color: #728198; font-size: 12px; }
.launch-error-reason p { margin: 8px 0 0; line-height: 1.7; white-space: pre-line; overflow-wrap: anywhere; }
.launch-error-help { margin: 16px 0 0; font-size: 13px; line-height: 1.7; color: #728198; }
.launch-error-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 24px; }
.launch-error-actions button { min-height: 44px; padding: 12px; border-radius: 10px; background: #eef4fa; color: #344863; }
.launch-error-actions .primary { color: #fff; background: #198acb; }
button:focus-visible { outline: 3px solid #82caff; outline-offset: 3px; }
button:hover { filter: brightness(.95); }
button:active { transform: translateY(1px); }
@media (max-width: 480px) { .launch-error-dialog { padding: 24px; } }
</style>
